import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, propsToClassKey } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import { Grid, TextField } from '@mui/material';
import { SetFormState } from '../../../actions/IncidentTrackerActions';

const schema = {
	priority: {
		presence: { allowEmpty: false, message: 'is required' },
	}
};

const useStyles = makeStyles((theme) => ({
	root: {},
	container: {
		marginTop: theme.spacing(3)
	},
	fields: {
		margin: theme.spacing(-1),
		display: 'flex',
		flexWrap: 'wrap',
		'& > *': {
			flexGrow: 1,
			margin: theme.spacing(1),
		},
	},
	submitButton: {
		marginTop: theme.spacing(2),
		width: '100%',
	},
	divider: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},
	noBorder: {
		border: 'none',
	}
}));

const IncidentConfigurationPriorityForm = (props) => {
	const classes = useStyles();
	const { onChange, disabled, defaultConfig = undefined, ...rest } = props;
	const [priority, setPriority] = useState(defaultConfig?.priority ?? '');
	const id = defaultConfig?.id;
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.incidentTrackerReducer.formState);

	const updateFormState = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	const _handlePriorityChange = (event) => {
		setPriority(event.target.value);
		updateFormState(event);
		onChange({ id, name: 'priority', value: event.target.value });
	};

	useEffect(() => {
		const errors = validate(formState.values, schema);
		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
		});
	}, [formState.values]);

	useEffect(() => {
		setFormState({
			...formState,
			values: {
				priority
			}
		});
	}, []);

	const hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));

	return (
		<Grid
			className={classes.container}
			container
			md={12}
			xs={12}
		>
			<Grid item md={6} xs={6}>
				<TextField
					id="priority"
					name="priority"
					disabled={disabled}
					label="Priority"
					hintText="Add a value"
					variant="outlined"
					fullWidth
					value={priority || ''}
					onChange={_handlePriorityChange}
					error={hasError('priority')}
					helperText={
						hasError('priority') ? formState.errors.priority[0] : null
					}
				/>
			</Grid>
		</Grid>
	);
};

IncidentConfigurationPriorityForm.propTypes = {
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	defaultConfig: PropTypes.object
};

export default IncidentConfigurationPriorityForm;
